import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { type LayoutProps, PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
import type { DonationFormSearchParams } from '../../../_dependencies/operations/getDonationFormConfig/getDonationFormConfigSchema'
export const pageUrl = '/[locale]/donate/[channel]/[receiver-type]/[slug]'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type DonatePageProps = PageProps<typeof pageUrl, DonationFormSearchParams>
export type DonateLayoutProps = LayoutProps<typeof pageUrl>
